import React, { useEffect, useState } from "react";
import FlashinqKitImage from "../../../assets/images/Defence/Products/FlashingKit.png";

//  FLASHING KIT – SECTION COMPONENT (NO CONFLICT DESIGN)
const FlashingKit = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 992);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 992);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  /*  GMAIL ENQUIRY HANDLER (FLASHING KIT) */
  const handleMail = () => {
    const email = "sales@combatsolutions.ai";   //  Receiver
    const subject = "Enquiry – Software Flashing Kit for Radar Systems";

    const body = `Hello Combat Solutions Team,

I am interested in receiving detailed product information for the Software Flashing Kit for Radar Systems.

Product: Software Flashing Kit for Radar Systems

Company Name:
Designation:
Contact Number:
Radar Platform / Application:

Additional Requirements / Questions:


Regards,
`;

    const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(
      email
    )}&su=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

    window.open(gmailUrl, "_blank");
  };

  //  FLASHING KIT – STYLE NAMESPACE (SAFE & ISOLATED)
  const flashStyles = {
    flashSection: {
      width: "100%",
      padding: isMobile ? "40px 24px" : "60px 60px",
      backgroundColor: "#ffffff",
    },

    flashContainer: {
      display: "flex",
      flexDirection: isMobile ? "column" : "row",
      gap: isMobile ? "40px" : "80px",
      alignItems: "center",
      justifyContent: "space-between",
      maxWidth: "1400px",
      margin: "0 auto",
    },

    /* LEFT IMAGE */
    flashImageBox: {
      flex: 1,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },

    flashMainImage: {
      width: "100%",
      maxWidth: isMobile ? "320px" : "560px",
      objectFit: "contain",
    },

    /* RIGHT CONTENT */
    flashContent: {
      flex: 1,
      display: "flex",
      flexDirection: "column",
    },

    flashBadge: {
      display: "inline-block",
      backgroundColor: "#fff2e6",
      color: "#ff7a00",
      padding: "6px 14px",
      borderRadius: "20px",
      fontSize: "12px",
      fontWeight: 600,
      marginBottom: "18px",
      alignSelf: isMobile ? "center" : "flex-start",
    },

    flashTitle: {
      fontSize: isMobile ? "26px" : "36px",
      fontWeight: 700,
      color: "#0f172a",
      marginBottom: "18px",
      lineHeight: 1.3,
      textAlign: isMobile ? "center" : "left",
    },

    flashDescription: {
      fontSize: isMobile ? "14px" : "16px",
      color: "#64748b",
      lineHeight: 1.7,
      marginBottom: "36px",
      maxWidth: "560px",
      textAlign: isMobile ? "center" : "left",
      alignSelf: isMobile ? "center" : "flex-start",
    },

    /* ICON GRID */
    flashIconGrid: {
      display: "grid",
      gridTemplateColumns: isMobile ? "repeat(2, 1fr)" : "repeat(3, 1fr)",
      gap: "24px",
      marginBottom: "40px",
      maxWidth: "520px",
      alignSelf: isMobile ? "center" : "flex-start",
    },

    flashIconBox: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: "10px",
      textAlign: "center",
    },

    flashIconCircle: {
      width: "56px",
      height: "56px",
      borderRadius: "14px",
      backgroundColor: "#fff2e6",
      border: "3px solid #ffdfc1",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "#ff7a00",
      fontSize: "26px",
    },

    flashIconText: {
      fontSize: "13px",
      color: "#0f172a",
      fontWeight: 500,
      lineHeight: 1.4,
    },

    flashButton: {
      marginTop: "10px",
      backgroundColor: "#ff7a00",
      color: "white",
      padding: "14px 30px",
      border: "none",
      borderRadius: "30px",
      fontSize: "14px",
      fontWeight: 600,
      cursor: "pointer",
      transition: "all 0.3s ease",
      alignSelf: isMobile ? "center" : "flex-start",
    },
  };

  return (
    <section style={flashStyles.flashSection}>
      <div style={flashStyles.flashContainer}>

        {/* LEFT IMAGE */}
        <div style={flashStyles.flashImageBox}>
          <img
            src={FlashinqKitImage}
            alt="Software Flashing Kit"
            style={flashStyles.flashMainImage}
          />
        </div>

        {/* RIGHT CONTENT */}
        <div style={flashStyles.flashContent}>
          <span style={flashStyles.flashBadge}>
            PORTABLE • RUGGED • MISSION-READY
          </span>

          <h2 style={flashStyles.flashTitle}>
            Software Flashing Kit for <br /> Radar Systems
          </h2>

          <p style={flashStyles.flashDescription}>
            A portable and ruggedized solution designed for software loading,
            updating, and maintenance of radar systems and mission-critical
            equipment.
          </p>

          {/* ICON GRID */}
          <div style={flashStyles.flashIconGrid}>

            <div style={flashStyles.flashIconBox}>
              <div style={flashStyles.flashIconCircle}>
                <i className="bi bi-briefcase-fill"></i>
              </div>
              <div style={flashStyles.flashIconText}>Portable Rugged Kit</div>
            </div>

            <div style={flashStyles.flashIconBox}>
              <div style={flashStyles.flashIconCircle}>
                <i className="bi bi-radar"></i>
              </div>
              <div style={flashStyles.flashIconText}>Radar System Support</div>
            </div>

            <div style={flashStyles.flashIconBox}>
              <div style={flashStyles.flashIconCircle}>
                <i className="bi bi-gear-fill"></i>
              </div>
              <div style={flashStyles.flashIconText}>
                Software Loading & Updates
              </div>
            </div>

            <div style={flashStyles.flashIconBox}>
              <div style={flashStyles.flashIconCircle}>
                <i className="bi bi-geo-alt-fill"></i>
              </div>
              <div style={flashStyles.flashIconText}>Field Deployment Ready</div>
            </div>

            <div style={flashStyles.flashIconBox}>
              <div style={flashStyles.flashIconCircle}>
                <i className="bi bi-shield-fill-check"></i>
              </div>
              <div style={flashStyles.flashIconText}>
                Equipment Safety & Reliability
              </div>
            </div>

            <div style={flashStyles.flashIconBox}>
              <div style={flashStyles.flashIconCircle}>
                <i className="bi bi-wrench-adjustable-circle-fill"></i>
              </div>
              <div style={flashStyles.flashIconText}>Customizable Design</div>
            </div>

          </div>

          {/*  GMAIL TRIGGER BUTTON */}
          <button style={flashStyles.flashButton} onClick={handleMail}>
            Request Product Information
          </button>
        </div>
      </div>
    </section>
  );
};

export default FlashingKit;
